/**
 * Shared typography styles for PCW components.
 * Based on the PCW style guide:
 * - GT America Mono for labels, badges, and UI elements
 * - Canela for headings
 * - Helvetica Neue for body text and values
 */

/** Label style for form fields and section headers */
export const labelStyle = {
  fontFamily: "'GT America Mono', 'Courier New', monospace",
  fontSize: '12px',
  fontWeight: 700,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.5px'
} as const

/** Compact label style without size/weight (for inline use) */
export const labelFontStyle = {
  fontFamily: "'GT America Mono', 'Courier New', monospace" as const
} as const

/** Badge style for tags and category badges */
export const badgeStyle = {
  fontFamily: "'GT America Mono', 'Courier New', monospace" as const
} as const

/** Value/body text style for form values and descriptions */
export const valueStyle = {
  fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  fontWeight: 400
} as const

/** Heading style using Canela font */
export const headingStyle = {
  fontFamily: "'Canela', Georgia, serif"
} as const
